const formatMessageContent = (content) => {
  if (!content) return "";

  let formattedContent = content;

  const applyHorseNbsp = (text) =>
    typeof text === "string"
      ? text.replace(/(\d+)\.\s*/g, "$1.&nbsp;")
      : text;

  // Process the different formatting patterns in a specific order to avoid conflicts

  // 1. First handle the most specific pattern: bold-italic
  formattedContent = formattedContent.replace(
    /\*\*_([^*_]+)_\*\*/g,
    (_, inner) =>
      `<span class="horse-reference">${applyHorseNbsp(inner)}</span>`,
  );

  // 2. Handle bold text
  formattedContent = formattedContent.replace(
    /\*\*([^*]+)\*\*/g,
    (_, inner) => `<strong>${applyHorseNbsp(inner)}</strong>`,
  );

  // 3. Handle italic text with asterisks - updated to be bold AND italic
  formattedContent = formattedContent.replace(
    /\*([^*]+)\*/g,
    (_, inner) => `<em><strong>${applyHorseNbsp(inner)}</strong></em>`,
  );

  // 4. Handle italic text with underscores (keep this as a fallback)
  formattedContent = formattedContent.replace(/_([^_]+)_/g, "<em>$1</em>");

  // 4. Process lists - first split into lines to properly handle multi-line lists
  const lines = formattedContent.split("\n");
  const processedLines = lines.map((line) => {
    // Check for bullet list items
    const bulletMatch = line.match(/^[\-\*]\s+(.+)$/);
    if (bulletMatch) {
      return `<div class="bullet-list">${bulletMatch[1]}</div>`;
    }

    // Check for numbered list items
    const numberedMatch = line.match(/^(\d+)\.\s+(.+)$/);
    if (numberedMatch) {
      return `<div class="numbered-list"><span class="list-number">${numberedMatch[1]}.</span> ${numberedMatch[2]}</div>`;
    }

    return line;
  });

  // 5. Join lines back with <br> tags for proper line breaks
  formattedContent = processedLines.join("<br>");

  return formattedContent;
};

export default formatMessageContent;
